import { MapTo } from '@adobe/aem-react-editable-components';
import BankingDualAd, { BankingDualAdEditConfig } from './BankingDualAd';

export default MapTo('cob-corp-acquisition/components/creditonebank/banking-dual-ad')(BankingDualAd, BankingDualAdEditConfig);